export const AuthSortides = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Responsabilització sortides
        </h4>
        <p>
          <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortides"> Em RESPONSABILITZO dels desplaçaments que faci pel meu compte cap/des de punts preestablerts en activitats i sortides del centre.  </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

        <br />

      </div>
    </div>
  </>)
}

export const AuthSortidesMenors = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Autorització per a realitzar activitats fora del centre
        </h4>
        <p>
          <input type="checkbox" id="authSortides" name="authSortides" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authSortides">
            AUTORITZO a l'alumne/a matriculat/ada a:
            <ul>
              <li>participar en totes les activitats i sortides formatives fora del centre.</li>
              <li>desplaçar-se/tornar pel seu compte fins a/des d'un punt de trobada preestablert en
                activitats o sortides fora del centre.</li>

            </ul>

          </label>
          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}
